import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpotlightComponent } from './simple-icons-spotlight.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpotlightComponent ],
    exports:      [ SimpleIconsSpotlightComponent ],
    bootstrap:    []
})
export class SimpleIconsSpotlightModule {}
